module.exports = __webpack_public_path__ + "static/img/download_bj.f9d01c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/downLoad/download_bj.png
// module id = Uj/t
// module chunks = 1